import { API_ENDPOINT_OPENAI_PARSE_RECEIPT } from "src/helpers/endpoint-urls";
import apiClient from "../helpers/api-client";

export const parseOcrReceipt = (file: File, instructions?: string) => {
  const fd = new FormData();
  fd.append("image", file, file.name); // <<— clave debe ser "image"
  if (instructions) fd.append("instructions", instructions);

  return apiClient.post(API_ENDPOINT_OPENAI_PARSE_RECEIPT, fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};
